import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Select, Tooltip, DatePicker, message } from 'antd';
import { Defines } from '../../../../../project/Defines';
import {
  setLoadStatusData,
  setStopDetailsStatusData,
  setItemDisplayState,
  setCurrentUser,
  setOrderDateDetails,
  setStopDateDetails,
  setOrderDeliverDateDetails,
} from '../../../../../store/actions/callCheckLoadsActions/callCheckLoads';
import { GenerateMessages } from '../../../../helper/element';
import './index.css';
import { CallCheckLoadsSelectors } from '../../../../../store/selectors/callCheckLoadsSelectors';
import NotesModal from './NotesModal';

const Cell = ({ cellData, itemSize, rowState, resource, page, isAppointmentInPast, type }) => {
  const dispatch = useDispatch();
  const { state, userFirstName, loadDetails } = CallCheckLoadsSelectors();
  const [orderNotesModalIsOpen, setOrderNotesModalIsOpen] = useState(false);
  const [currentStopStatus, setCurrentStopStatus] = useState(null);
  const loadArea = state[resource];
  const readonly = 1;
  const editable = 2;
  let header = '';
  if (type === 'pick') {
      header = loadArea.detailsPageHeadersPick.find(h => h.key === cellData.key)
  } else {
      header = loadArea.detailsPageHeadersDrop.find(h => h.key === cellData.key)
  }

  const selectOptionsPalletTypes = { 
      1: 'Straight', 
      2: 'Chimney', 
      3: 'Other', 
      4: 'Sideways'
  };

  const selectNameOptionsStopStatusCurrentAndIssueLoads = [
    { name: '-', id: null },
    { name: 'Ready to be Pick Up', id: 1 },
    { name: 'On the Way', id: 2 },
    { name: 'Near Location ', id: 3 },
    { name: 'On-Site', id: 4 },
    { name: 'In-Door Process', id: 5 },
    { name: 'In Transit', id: 6 },
    { name: 'Delayed', id: 7 },
    { name: 'Delivered', id: 8 },
    { name: 'Issue', id: 9 },
  ];

  const selectOptionsStopStatusCurrentAndIssueLoads = {
    null: '-',
    0: '-',
    1: 'Ready to be Pick Up',
    2: 'On the Way',
    3: 'Near Location',
    4: 'On-Site',
    5: 'In-Door Process',
    6: 'In Transit',
    7: 'Delayed',
    8: 'Delivered',
    9: 'Issue',
  };

  const selectNameOptionsStopStatusPastLoads = [
    { name: '-', id: null },
    { name: 'Delayed', id: 8 },
    { name: 'Issue', id: 9 },
  ];

  const selectOptionsStopStatusPastLoads = {
    null: '-',
    0: '-',
    8: 'Delayed',
    9: 'Issue',
  };

  const width = header.width;
  const [displayState, setDisplayState] = useState(readonly);
  const [tempData, setTempData] = useState(null);

  useEffect(() => {
    if (cellData.key === 'status' && cellData.editable) {
      setDisplayState(editable);
    }
  }, [cellData.editable, cellData.key, resource]);

  const data = cellData.value;
  const cellStyle = cellData.cellStyle;
  const tooltip = cellData.tooltip;
  const color = rowState.type === 'load' || rowState.type === 'dropLoad' ? 'white' : '#101C1C';

  useEffect(() => {
    setTempData(data);
  }, [data]);

  const inputReference = useRef(null);

  const dataCompare = (newData, data) => {
    switch (cellData.fieldType) {
      case 'date':
      case 'dateTime':
        if (newData instanceof Date && data instanceof Date) {
          return newData.getTime() === data.getTime();
        }
        return newData === data;
      default:
        return newData === data;
    }
  };

  const handleFlagUpdate = useCallback(() => {
    dispatch(setCurrentUser(resource, rowState, userFirstName));
  }, [dispatch, resource, rowState, userFirstName]);

  const handleDateUpdate = value => {
    onSetBlur();
    if (!dataCompare(value, tempData)) {
      setTempData(value);
      setTimeout(() => {
        if (header.key === 'deliverDate') {
          dispatch(setOrderDeliverDateDetails(resource, page, value, rowState, header));
        } else {
          // pick / drop / puDate
          if (rowState.type === 'stop') {
            dispatch(setStopDateDetails(resource, page, value, rowState, header));
          } else if (rowState.type === 'order') {
            // for puDate for order
            dispatch(setOrderDateDetails(resource, page, value, rowState, header));
            console.log(rowState)
          }
        }
      }, 100);
    }
  };

  const handleValidationForPickDropInOut = useCallback(
    value => {
      let errorText;
      if (header?.key === 'checkOut') {
        if (rowState.loadType === 'pickLoad' && !rowState.stopData.pickIn && value) {
          errorText = 'Please enter Pick In before adding Pick Out';
        }
        if (rowState.loadType === 'dropLoad' && !rowState.stopData.dropIn && value) {
          errorText = 'Please enter Drop In time before adding Drop Out';
        }
      } else {
        const isPickOut = loadArea?.loadDetails.pickStop?.filter(stop => stop.pickOut).length === loadArea?.loadDetails.pickStop?.length;
        if (rowState.loadType === 'dropLoad' && !isPickOut && value) {
          errorText = 'Please enter Pick In and Pick Out time before adding Drop In';
        }
      }

      return errorText;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [header, rowState],
  );

  const handleValidationForPickDropInOutForDelete = value => {
    let errorText;
      if (header?.key === 'pickIn' && rowState.stopData.pickOut && value === null) {
          errorText = 'Error: Cannot remove Pick In with Pick Out set';
      }
      if (header?.key === 'dropIn' && rowState.stopData.dropOut && value === null) {
          errorText = 'Error: Cannot remove Drop In with Drop Out set';
      }
      if (rowState.loadType === 'pickOut' && rowState.stopData.dropIn && value === null) {
          errorText = 'Error: Cannot remove Pick Out with Drop In set';
    }
    return errorText;
  }

  const getData = () => {
    if (tempData !== '') {
      switch (cellData.fieldType) {
        case 'dateTime':
          if (tempData) {
            return (
              <div className='date-time__container'>
                <div className='loads__date__part'>{tempData ? moment(tempData).format(Defines.Format.Date) : ''}</div>
                <div className='loads__time__part'>{tempData ? moment(tempData).format(Defines.Format.Time) : ''}</div>
              </div>
            );
          } else {
            return <span className='call-check-loads__select-date__title'>Select date</span>;
          }
        case 'date':
          if (tempData) {
            return (
              <div className='date-time__container'>
                <div>{tempData ? moment(tempData).format(Defines.Format.Date) : ''}</div>
              </div>
            );
          } else {
            return <span className='call-check-loads__select-date__title'>Select</span>;
          }
        case 'flag':
          if (tempData) {
            return (
              <Tooltip title={`User name - ${tempData}`}>
                <div className='flag_container' onClick={() => handleFlagUpdate()}>
                  <svg width='14' height='14' viewBox='0 0 18 20' fill='#FFEA00' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M17.1788 1.86667C16.9219 1.6839 16.6251 1.5635 16.3124 1.51524C15.9996 1.46698 15.6798 1.49221 15.3788 1.58889C14.5847 1.80943 13.7623 1.91424 12.9375 1.9C11.7187 1.83466 10.5236 1.54052 9.41626 1.03333C8.04828 0.40848 6.56859 0.0572844 5.06251 0C1.81127 0 0.562519 1.11111 0.337519 1.26667C0.229866 1.37088 0.144516 1.4954 0.0865386 1.63283C0.0285612 1.77026 -0.000861205 1.91779 1.91891e-05 2.06667V18.8889C1.91891e-05 19.1836 0.118546 19.4662 0.329524 19.6746C0.540502 19.8829 0.82665 20 1.12502 20C1.42339 20 1.70953 19.8829 1.92051 19.6746C2.13149 19.4662 2.25002 19.1836 2.25002 18.8889V14.1111C3.14645 13.7721 4.10342 13.6171 5.06251 13.6556C6.28135 13.7209 7.47641 14.015 8.58376 14.5222C9.95174 15.1471 11.4314 15.4983 12.9375 15.5556C14.2937 15.6061 15.6428 15.3396 16.875 14.7778C17.2071 14.6237 17.4887 14.3805 17.6876 14.076C17.8865 13.7715 17.9948 13.4179 18 13.0556V3.45556C17.9996 3.14553 17.925 2.83998 17.7823 2.56385C17.6396 2.28772 17.4328 2.04883 17.1788 1.86667Z' />
                  </svg>
                </div>
              </Tooltip>
            );
          } else {
            return (
              <div className='flag_container' onClick={() => handleFlagUpdate()}>
                <svg width='14' height='14' viewBox='0 0 18 20' fill='#fff' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M17.1788 1.86667C16.9219 1.6839 16.6251 1.5635 16.3124 1.51524C15.9996 1.46698 15.6798 1.49221 15.3788 1.58889C14.5847 1.80943 13.7623 1.91424 12.9375 1.9C11.7187 1.83466 10.5236 1.54052 9.41626 1.03333C8.04828 0.40848 6.56859 0.0572844 5.06251 0C1.81127 0 0.562519 1.11111 0.337519 1.26667C0.229866 1.37088 0.144516 1.4954 0.0865386 1.63283C0.0285612 1.77026 -0.000861205 1.91779 1.91891e-05 2.06667V18.8889C1.91891e-05 19.1836 0.118546 19.4662 0.329524 19.6746C0.540502 19.8829 0.82665 20 1.12502 20C1.42339 20 1.70953 19.8829 1.92051 19.6746C2.13149 19.4662 2.25002 19.1836 2.25002 18.8889V14.1111C3.14645 13.7721 4.10342 13.6171 5.06251 13.6556C6.28135 13.7209 7.47641 14.015 8.58376 14.5222C9.95174 15.1471 11.4314 15.4983 12.9375 15.5556C14.2937 15.6061 15.6428 15.3396 16.875 14.7778C17.2071 14.6237 17.4887 14.3805 17.6876 14.076C17.8865 13.7715 17.9948 13.4179 18 13.0556V3.45556C17.9996 3.14553 17.925 2.83998 17.7823 2.56385C17.6396 2.28772 17.4328 2.04883 17.1788 1.86667Z' />
                </svg>
              </div>
            );
          }
        case 'text':
          if (header.key === 'notes') {
            return (
              <div style={{ cursor: 'pointer' }} onClick={() => setOrderNotesModalIsOpen(true)}>
                {tempData}
              </div>
            )
          } else if (header.key === 'sequence') {
            return <div>{selectOptionsPalletTypes[tempData]}</div>
          } else {
            return <div>{tempData}</div>
        }
        case 'select':
          const selectOption = page === 'pastLoads' ? selectOptionsStopStatusPastLoads : selectOptionsStopStatusCurrentAndIssueLoads;
          return <div className='load-details__orderStatus'>{selectOption[tempData]}</div>
        case 'action':
            return (
                <div className='load-details__edit_icons-callcheck'>
                  <div onClick={() => setOrderNotesModalIsOpen(true)}>
                      <svg width="19" height="18" viewBox="0 0 19 18" fill="black" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.1965 6.02L12.1165 6.94L3.05647 16H2.13647V15.08L11.1965 6.02ZM14.7965 0C14.5465 0 14.2865 0.1 14.0965 0.29L12.2665 2.12L16.0165 5.87L17.8465 4.04C18.2365 3.65 18.2365 3.02 17.8465 2.63L15.5065 0.29C15.3065 0.09 15.0565 0 14.7965 0ZM11.1965 3.19L0.136475 14.25V18H3.88647L14.9465 6.94L11.1965 3.19Z" fill="#3C8680"/>
                      </svg>
                  </div>
                </div>
            );
        default:
          return tempData;
      }
    }
    return tempData;
  };

  const handleSelectChangeStatus = value => {
    onSetBlur();
    setCurrentStopStatus(value);
    if (rowState.type === 'stop') {
      if (!dataCompare(value, tempData)) {
        setTempData(value);
          setTimeout(() => {
            dispatch(setStopDetailsStatusData(resource, page, value, rowState));
          }, 100);
      }
    } else {
      if (!dataCompare(value, tempData)) {
        setTempData(value);
        setTimeout(() => {
          dispatch(setLoadStatusData(resource, page, value, rowState));
        }, 100);
      }
    }
  };

  const getInput = () => {
    switch (cellData.fieldType) {
      case 'dateTime':
        return (
          <DatePicker
            open={displayState === editable}
            ref={inputReference}
            onBlur={() => {
              setTimeout(() => {
                if (inputReference.current) {
                  setDisplayState(readonly);
                }
              }, 0);
            }}
            suffixIcon={null}
            showTime
            minuteStep={15}
            className='spreadsheet-picker'
            value={tempData ? moment(tempData) : null}
            format={Defines.Format.PrintDateTime}
            placeholder='Select date'
            onKeyDown={e => {
              if (e.key === 'Escape') {
                onSetBlur();
                if (inputReference.current) {
                  setDisplayState(readonly);
                }
              }
            }}
            onChange={value => {
              let errorTextNextDate = handleValidationForPickDropInOut(value);
              let errorTextDeleteNextDate = handleValidationForPickDropInOutForDelete(value);
              const carrierName = loadDetails.carrierName;
              let noCarrierErrorText = '';
              if (!carrierName) {
                  noCarrierErrorText = 'Cannot add Pick In without an assigned carrier';
              }
              if (errorTextNextDate || errorTextDeleteNextDate || noCarrierErrorText) {
                onSetBlur();
                setTimeout(() => {
                  if (inputReference.current) {
                    setDisplayState(readonly);
                  }
                  errorTextNextDate && message.error(errorTextNextDate);
                  errorTextDeleteNextDate && message.error(errorTextDeleteNextDate);
                  noCarrierErrorText && message.error(noCarrierErrorText);
                }, 0);
              } else {
                onSetBlur();
                handleDateUpdate(value ? value._d : null);
                setTimeout(() => {
                  setDisplayState(readonly);
                }, 500);
              }
            }}
          />
        );
      case 'date':
        return (
          <DatePicker
            open={displayState === editable}
            ref={inputReference}
            onBlur={() => {
              setTimeout(() => {
                if (inputReference.current) {
                  setDisplayState(readonly);
                }
              }, 0);
            }}
            suffixIcon={null}
            className='spreadsheet-picker'
            value={tempData ? moment(tempData) : ''}
            format={Defines.Format.PrintDate}
            placeholder='Select date'
            onKeyDown={e => {
              if (e.key === 'Escape') {
                onSetBlur();
                if (inputReference.current) {
                  setDisplayState(readonly);
                }
              }
            }}
            onChange={value => {
              let errorText = handleValidationForPickDropInOut(value);
              if (errorText) {
                onSetBlur();
                setTimeout(() => {
                  setDisplayState(readonly);
                  message.error(errorText)
                }, 500);
              } else {
                onSetBlur();
                handleDateUpdate(value ? value._d : '');
                setTimeout(() => {
                  setDisplayState(readonly);
                }, 500);
              }
            }}
          />
        );
      case 'select':
        const selectOption = page === 'pastLoads' ? selectOptionsStopStatusPastLoads : selectOptionsStopStatusCurrentAndIssueLoads;
        const selectNameOptions = page === 'pastLoads' ? selectNameOptionsStopStatusPastLoads : selectNameOptionsStopStatusCurrentAndIssueLoads;
        return (
          <Select
            ref={inputReference}
            value={selectOption[`${tempData}`]}
            className={` 
                  ${rowState.type === 'stop' ? 'rowSelectStop' : 'rowSelectLoad'} 
                  ${rowState?.isSub ? 'sub_order_cell' : ''}
              `}
            onChange={handleSelectChangeStatus}
            defaultValue={selectOption[tempData]}>
            {selectNameOptions.map((item, index) => (
              <Select.Option key={index} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        );
      default:
        return <></>;
    }
  };

  const getDataWithTooltip = () =>
    tooltip ? (
      <Tooltip title={GenerateMessages([tooltip])}>{displayState === readonly ? getData() : getInput()}</Tooltip>
    ) : displayState === readonly ? (
      getData()
    ) : (
      getInput()
  );

  const dataDisplay = () => getDataWithTooltip();

  const cellDefaultStyle = {
    maxWidth: `${width}px`,
    width: `${width}px`,
    minWidth: `${width}px`,
    height: `${itemSize}px`,
    lineHeight: 'inherit',
  };

  const onSetFocus = () => {
    if (cellData.editable) {
      setDisplayState(editable);
    }
  };

  const onSetBlur = () => {
    dispatch(setItemDisplayState(resource, rowState, header, false));
  };

  const editableFunction = cellData => (cellData.editable ? setDisplayState(editable) : null);

  return (
    <>
      <div
        onFocus={() => onSetFocus()}
        onClick={() => {
          editableFunction(cellData);
        }}
        className={`table-body-cell ${isAppointmentInPast && header.key === 'pickAppointment' ? 'redBG' : ''}`}
        style={{ ...cellDefaultStyle, ...cellStyle, color: color }}
        tabIndex={displayState === readonly ? 0 : -1}>
        {dataDisplay()}
      </div>
      {orderNotesModalIsOpen && (
        <NotesModal
          orderNotesModalIsOpen={orderNotesModalIsOpen}
          setOrderNotesModalIsOpen={setOrderNotesModalIsOpen}
          rowState={rowState}
          resource={resource}
          page={page}
        />
      )}
    </>
  );
};

export default Cell;
